import { withInstall } from "@chenzoho/vue-install"
import scrollContainer from "./ScrollContainer.vue"

export const VScrollContainer = withInstall(scrollContainer)

export * from "./types"
